import { apiClient } from '~/api';
import type { Strapi5RequestParams, Strapi5ResponseMany } from '@nuxtjs/strapi';
import type { BlogArticle } from '~/types/blogArticle';

interface Params {
  categorySlug?: string;
  tagSlug?: string;
  locale: string;
  page: number;
  pageSize?: number;
}

export default async function getBlogArticles(payload: Params) {
  const params: Params = {
    pageSize: 20,
    ...payload,
  };

  return await apiClient<Strapi5ResponseMany<BlogArticle>>('/blog-articles', {
    cacheKey: getApiRequestCacheKey(
      'blogArticles',
      params as unknown as ApiRequestParams,
    ),
    params: {
      locale: params.locale,
      populate: {
        image: true,
        tags: true,
      },
      filters: getFilters(params),
      pagination: {
        page: params.page,
        pageSize: params.pageSize,
      },
    },
  });
}

function getFilters(params: Params) {
  const filters: Strapi5RequestParams['filters'] = {};

  if (params.categorySlug) {
    filters.category = {
      slug: params.categorySlug,
    };
  }

  if (params.tagSlug) {
    filters.tags = {
      slug: params.tagSlug,
    };
  }

  return filters;
}
